import React, { Component } from 'react'
import { connect } from "react-redux";
import classnames from 'classnames';
import { get } from 'lodash'

import { profileLogout } from '../store/profile/actions'
// import logo from './../img/lr-logo.svg';

import Button from './shared/Button';
import { Dropdown, Panel } from './shared/Dropdown';


import logo from 'custom/img/logo-dark.svg';
import baseStyles from 'custom/base.styl';
import styles from 'custom/layout.styl';

class ProfileUserDropDown extends Component {
  constructor(props) {
    super(props)

    this.state = {
      isOpen: false,
    };

    this.onOpenChange = this.onOpenChange.bind(this);
    this.onClick = this.onClick.bind(this);
    this.renderName = this.renderName.bind(this)
  }

  onOpenChange(value) {
    this.setState({ isOpen: value });
  }

  onClick() {
    this.props.profileLogout();
    this.setState({ isOpen: false });
  }

  renderName() {
    const { data } = this.props
    const firstName = get(data, 'user.profile.first_name')
    const phone = get(data, 'user.profile.phone')
    const email = get(data, 'user.email')
    return ((firstName && firstName.trim()) || phone) || email
  }

  render() {
    const { isOpen } = this.state;
    const { balance, version } = this.props;

    const className = classnames(baseStyles.profile, { [baseStyles.with_divider]: balance && version === 'v1' });

    return (
      <div className={className}>
        Hello, <Button empty onClick={this.onOpenChange}>{this.renderName()}</Button>
        <Dropdown onOpenChange={this.onOpenChange} isOpen={isOpen} positionRight>
          <Panel>
            <i className={baseStyles.icon_logout} />
            <a onClick={this.onClick} rel="noopener noreferrer">logout</a>
          </Panel>
        </Dropdown>
      </div>
    )
  }
}

const ProfileHeader = props => {
  const { data, balance, profileLogout, version } = props;
  const balanceText = Number.isInteger(balance) ? Math.floor(balance / 100) : 0;

  return (
    <header className={styles.header}>
      <div className={styles.container}>
        <div className={styles.header_content}>
          <img src={logo} className={styles.logo} alt="logo" />

          {version === 'v0' &&
            <ProfileSteps
              data={data}
            />
          }

          <div className={styles.header_right}>
            {!!balance && version === 'v1' &&
              <div className={styles.balance}>
                <i className={styles.icon_wallet} />
                Balance: <b>${balanceText}</b>
              </div>
            }

            {!!data &&
              <ProfileUserDropDown
                data={data}
                balance={balance}
                profileLogout={profileLogout}
              />
            }
          </div>
        </div>
      </div>
    </header>
  );
};

const mapStateToProps = state => {
  const data = state && state.profile && state.profile.data;
  const balance = data && data.user && data.user.balance;
  const version = data && data.user && data.user.scenario_version;
  return { data, balance, version };
};

const mapDispatchToProps = dispatch => ({
  profileLogout: () => dispatch(profileLogout()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProfileHeader);

const PROGRESS = {
  'applicant_info': baseStyles.step1,
  'language_test': baseStyles.step1,
  'language_test_failed': baseStyles.step1,
  'phone_verification': baseStyles.step1,
  'essay_welcome': baseStyles.step2,
  'essay_1': baseStyles.step2,
  'essay_1_success_v0': baseStyles.step3,
  'essay_2': baseStyles.step3,
  'essay_2_success_v0': baseStyles.step4,
  'essay_3': baseStyles.step4,
  'phone_verification_2': baseStyles.step4,
  'await_result': baseStyles.step5,
  'hired': baseStyles.step_complete,
  'declined': baseStyles.step5
}

const ProfileSteps = (props) => {
  const { data } = props
  const profileStage = get(data, 'user.stage')

  return (
    <div className={baseStyles.step_panel}>

      {/* <div className={classnames(baseStyles.scale, baseStyles.step2)}> */}
      {/* <div className={classnames(baseStyles.scale, baseStyles.step5)}> */}
      {/* <div className={classnames(baseStyles.scale, baseStyles.step_complete)}> */}
      <div className={classnames(baseStyles.scale, PROGRESS[profileStage])}>
        <i />
        <i />
        <i />
        <i />
        <i />
      </div>

      <ul>
        <li className={profileStage === 'language_test_failed'
          ? baseStyles.error : ''}><span>Language test</span></li>
        <li><span>1st Essay</span></li>
        <li><span>2nd Essay</span></li>
        <li><span>3rd Essay</span></li>
        <li className={profileStage === 'declined'
          ? baseStyles.error : ''}><span>Approval</span></li>
      </ul>

    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/ProfileHeader.js